import React from "react";
import { createRoot } from "react-dom/client";
import App from "./index";

class UsStateForecast {
  constructor(htmlNode, initialState) {
    createRoot(htmlNode).render(<App {...initialState} />);
  }
}

export default UsStateForecast;
